import { defineMessages } from 'react-intl';

export default defineMessages({
  dependantsTitle: 'Controls display of the following content.',
  dependenciesTitle: 'This content is only shown if:',
});
